// extracted by mini-css-extract-plugin
export var videoNormal = "videoBackground-module--videoNormal--m519W";
export var videoCover = "videoBackground-module--videoCover--bnk8x";
export var videoLoad = "videoBackground-module--videoLoad--lMz1R";
export var slowFade = "videoBackground-module--slowFade--VzXLF";
export var slideUp = "videoBackground-module--slideUp--jPer6";
export var slideUpLarge = "videoBackground-module--slideUpLarge--bAecz";